
import axios from "axios";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import { ICategoryQuery } from "../../models/category/query";
import { HttpClient, RequestParams } from "../../utils/api/http-client";
import { ICategory } from "../../models/category/response";
import { ICreateCategory, IExportCategoryExcel, IUpdateCategory } from "../../models/category/request";
import { ACCESS_TOKEN, LANGUAGE_CODE } from "../../utils/helpers/constants";

class CategoryService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getAllCategories = (query: ICategoryQuery, params?: RequestParams) =>
    this.http.request<IBaseListingResponse<ICategory>>({
      path: `/category`,
      method: "GET",
      query,
      ...params,
    });

  getCategory = (id: number, params?: RequestParams) =>
    this.http.request<ICategory>({
      path: `/category/${id}`,
      method: "GET",
      ...params,
    });

  createCategory = (data: ICreateCategory, params?: RequestParams) =>
    this.http.request<ICategory>({
      path: "/category",
      method: "POST",
      body: data,
      ...params,
    });

  updateCategory = (
    id: number,
    data: IUpdateCategory,
    params?: RequestParams
  ) =>
    this.http.request<ICategory>({
      path: `/category/${id}`,
      method: "PUT",
      body: data,
      ...params,
    });

  deleteCategory = (id: number, params?: RequestParams) =>
    this.http.request<ICategory>({
      path: `/category/${id}`,
      method: "DELETE",
      ...params,
    });

  exportExcel = (data: IExportCategoryExcel, query: ICategoryQuery) =>
    axios.post(
      ` ${process.env.REACT_APP_BASE_API_URL}/category/export`,
      data,
      {
        headers: {
          authorization: `Bearer ${
            localStorage.getItem(ACCESS_TOKEN) ||
            sessionStorage.getItem(ACCESS_TOKEN)
          }`,
          "Content-Type": "application/json",
          "accept-language": `${
            localStorage.getItem(LANGUAGE_CODE) ??
            process.env.REACT_APP_DEFAULT_LANGUAGE
          }`,
        },
        params: query,
        responseType: "arraybuffer",
      }
    );

      updateCategoriesArrangementList = (id: number, data: {
        "priority":number
      }, params?: RequestParams) =>
        this.http.request({
          path: `/category/update-priority/${id}`,
          method: "PUT",
          body: data,
          ...params,
        });
}

export default CategoryService;
